import { call, put, takeLatest } from 'redux-saga/effects';
import { userHelperActions } from 'store/user/helper-actions';
import { userActions } from 'store/user/index';
import {
	CreateConfirmUserType,
	createOrConfirmUser,
	userProfileRecentConversation,
} from 'apis';

function* fetchUserDetails(
	action: ReturnType<typeof userHelperActions.hydrateUser>,
) {
	try {
		yield put(userActions.setLoading(true));

		const user: CreateConfirmUserType = yield call(
			createOrConfirmUser,
			action.payload?.wallet_address ?? '',
		);
		yield put(userActions.setValidUser(user.ok));
		const userProfileAndConversation: CreateConfirmUserType = yield call(
			userProfileRecentConversation,
			action.payload?.wallet_address ?? '',
		);

		/*const token = AUTH_TOKEN;

		yield put(
			authActions.setLogin({
				address: action.payload.wallet_address,
				token,
			}),
		);*/
	} catch (e) {
	} finally {
		yield put(userActions.setLoading(false));
	}
}

export function* userSaga() {
	yield takeLatest(userHelperActions.hydrateUser.type, fetchUserDetails);
}
